module.exports = "https://trybtryb-legacy.web.app/img/square-over-special-mobile.341f4d0f.svg";